import React from 'react'

import { getHeaderStyled, IHProps } from './H.styled'

const HStyled = getHeaderStyled('h5', {
  fontSize: 1,
  fontWeight: 'normal',
  lineHeight: 1.5,
  letterSpacing: 0.3,
})

export class H5 extends React.PureComponent<
  IHProps & React.HtmlHTMLAttributes<HTMLHeadingElement>
> {
  public render() {
    return <HStyled {...this.props} />
  }
}
